////var app = app || {};
////window.app = app; // expose for inline javascripts (kendo server wrappers)
////app.cw = app.cw || {};
app.cw.clientvault = app.cw.clientvault || {};

$(function () {
	// submit form
	$(document.body).on('submit', '#cw_ajax_cv_uploader_form', function (e) {
		app.cw.clientvault.onSubmitReload(e);
	});

	$(document.body).on('click', '.cw_cv_upload_new_version', function (e) {
		e.preventDefault();
		const $grid = $(e.currentTarget).closest('.k-grid').data('kendoGrid');
		const dataItem = $grid.dataItem($(e.currentTarget).closest('tr'));
		app.cw.common.PopupModal.show('Upload New Version - ' + dataItem.Name, '/ClientVault/DocumentList?handler=UploadVersionFormPartial&documentId=' + dataItem.Id + '&folderId=' + dataItem.FolderId);
	});

	$(document.body).on('click', '.cw_cv_download_version', function (e) {
		e.preventDefault();
		const url = $(this).data('url');
		window.location.href = url;
	});

	$(document.body).on('click', '.cw_cv_version_history', function (e) {
		e.preventDefault();
		const $grid = $(e.currentTarget).closest('.k-grid').data('kendoGrid');
		const dataItem = $grid.dataItem($(e.currentTarget).closest('tr'));
		app.cw.common.PopupModal.show('Show Document Versions - ' + dataItem.Name, '/ClientVault/DocumentList?handler=DocumentVersionPartial&documentId=' + dataItem.Id);
	});

	$(document.body).on('click', '.cw_cv_upload_new', function (e) {
		e.preventDefault();
		
		app.cw.common.PopupModal.show('Upload File', '/ClientVault/DocumentList?handler=CreateDocumentUploadFormPartial');
	});

	$(document.body).on('click', '.cw_ajax_cv_edit_btn', function (e) {
		e.preventDefault();

		app.cw.clientvault.editDocument(e);
	});
});

app.cw.clientvault = {
	editDocument: function editDocument(e) {
		e.preventDefault();
		// get data of the selected row in the grid
		const grid = $(e.currentTarget).closest('.k-grid').data('kendoGrid');
		const dataItem = grid.dataItem($(e.currentTarget).closest('tr'));
		app.cw.common.PopupModal.show('Edit Uploaded File', '/ClientVault/DocumentList?handler=EditDocumentPartial&documentId=' + dataItem.Id);
	},
	fileTypeIcon: function fileTypeIcon(fileTypeId) {
		let markup = '';
		let iconCssClass;
		let title;

		switch (fileTypeId) {
			case 1:
				iconCssClass = 'fa-file-excel';
				title = 'Excel';
				break;
			case 2:
				iconCssClass = 'fa-file-word';
				title = 'Word';
				break;
			case 3:
				iconCssClass = 'fa-file-pdf';
				title = 'PDF';
				break;
			default:
				iconCssClass = 'fa-file-alt';
				title = 'File';
				break;
		}

		markup += '<i class="fas ' + iconCssClass + ' fa-fw " title="' + title + '"></i>';

		return markup;
	},
	forgeryToken: function forgeryToken() {
		return kendo.antiForgeryTokens();
	},
	onSubmitReload: function onSubmitReload(e) {
		e.preventDefault();
		$.ajax({
			type: 'POST',
			url: $('#cw_ajax_cv_uploader_form').prop('action'),
			dataType: 'json',
			data: $('#cw_ajax_cv_uploader_form').serialize(),
			beforeSend: function () {
				app.cw.common.LoadingSpinner.show();
			},
			complete: function (result) {
				app.cw.common.LoadingSpinner.hide();
			}
		}).done(function (result) {
			if (result.Error) {
				app.cw.common.Notification.show('Upload Failed', result.Message, 'error'); // title, message, type
			}
			else {
				app.cw.common.PopupModal.hide();
				app.cw.common.Notification.show('Upload Succeeded', result.Message, 'success'); // title, message, type

				$('#Documents').data('kendoGrid').dataSource.read();
			}
		});
	},
	onUploadSuccess: function onUploadSuccess(e) {
		if (e.response.tempFileName) {
			$('#TempFileName').val(e.response.tempFileName).trigger("change");
		}
	},
	onUploadRemove: function onUploadRemove(e) {
		e.data = {
			tempFileName: $('#TempFileName').val()
		};
		$('#TempFileName').val('');
	}
};